import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {UserInquiryValueObject} from "../../../data/value-object/user/UserInquiryValueObject";
import {UserInquirySearchOption} from "../../../data/search-option/user/UserInquirySearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {UserInquiryIO} from "../../../io/UserIO";
import {UserInquiryDescription} from "../../../data/description/user/UserInquiryDescription";
import {UserInquiryDescriptor} from "../../../data/descriptor/user/UserInquiryDescriptor";
import ListOption from "../../ListOption";
import {UserInquirySearchOptionDescription} from "../../../data/description/user/UserInquirySearchOptionDescription";
import {
    applyUserInquirySearchOption,
    UserInquirySearchOptionField
} from "../../search-option-field/user/UserInquirySearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<UserInquiryValueObject[]>([])
    const option = useStatePair<UserInquirySearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={UserInquiryIO}
                items={items}
                option={option.value}
                index={index}
                description={UserInquiryDescription}
                descriptor={UserInquiryDescriptor}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/users/inquiries/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={UserInquirySearchOptionDescription}
                fields={UserInquirySearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyUserInquirySearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={UserInquiryDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}